import React from 'react';
import { Box, Container, Divider, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import MovdLogo from './MovdLogo.jsx';

const navLinks = [
  { label: 'How it works', to: '/how-it-works' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
  { label: 'Start your move', to: '/?start=1' },
];

const legalLinks = [
  { label: 'Privacy Policy', to: '/privacy-policy.html', external: true },
  { label: 'Terms of Service', to: '/terms.html', external: true },
];

const linkSx = {
  color: '#30465f',
  fontSize: '.9rem',
  fontWeight: 700,
  textDecoration: 'none',
  '&:hover': { color: '#008d7b' },
  transition: 'color 0.15s',
};

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: '#f1fbfa', color: '#102449', borderTop: '1px solid #dceeea', py: { xs: 4, md: 4.5 } }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' }, gap: { xs: 3.5, md: 6 }, alignItems: 'end' }}>
          <Box>
            <MovdLogo size="medium" variant="full" />
            <Typography sx={{ mt: 1.25, color: '#52637c', fontSize: { xs: '.92rem', md: '1rem' }, lineHeight: 1.5, maxWidth: 345 }}>
              Plan your move, compare your options, and book with clarity.
            </Typography>
          </Box>
          <Box component="nav" aria-label="Footer" sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: { xs: 'flex-start', md: 'flex-end' }, gap: { xs: 2.25, md: 3.5 } }}>
              {navLinks.map(link => (
                <Typography key={link.to} component={Link} to={link.to} sx={linkSx}>
                  {link.label}
                </Typography>
              ))}
          </Box>
        </Box>

        <Divider sx={{ borderColor: '#cfe8e3', my: { xs: 3, md: 3.5 } }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography sx={{ color: '#6b7d93', fontSize: '.78rem' }}>
            © {new Date().getFullYear()} Movd Technologies Inc. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2.5}>
            {legalLinks.map(link => <Typography key={link.to} component="a" href={link.to} sx={{ ...linkSx, fontSize: '.78rem', fontWeight: 600 }}>{link.label}</Typography>)}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
